import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "media-display" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-warning mb-0"
}
const _hoisted_4 = {
  key: 2,
  class: "media-content"
}
const _hoisted_5 = ["src", "data-bs-target"]
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = { class: "modal-body text-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 4,
  class: "media-content"
}
const _hoisted_12 = ["data-bs-target"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_16 = { class: "modal-content" }
const _hoisted_17 = { class: "modal-header" }
const _hoisted_18 = { class: "modal-body text-center" }
const _hoisted_19 = ["id", "src"]
const _hoisted_20 = {
  key: 6,
  class: "media-content"
}
const _hoisted_21 = { class: "alert alert-info mb-0" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { key: 7 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("div", {
            class: "spinner-border spinner-border-sm text-primary",
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Cargando...")
          ], -1),
          _createElementVNode("p", { class: "small text-muted mt-2 mb-0" }, "Cargando multimedia...", -1)
        ]))]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1),
            _createTextVNode(" No se pudo cargar el archivo multimedia ", -1)
          ]))]))
        : (_ctx.mediaType === 'photo' && _ctx.mediaUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.mediaUrl,
                alt: "Imagen de Telegram",
                class: "img-fluid rounded telegram-media-image",
                onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args))),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openImageModal && _ctx.openImageModal(...args))),
                "data-bs-toggle": "modal",
                "data-bs-target": `#imageModal-${_ctx.uniqueId}`
              }, null, 40, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
    (_ctx.mediaType === 'photo' && _ctx.mediaUrl)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "modal fade",
          id: `imageModal-${_ctx.uniqueId}`,
          tabindex: "-1",
          role: "dialog"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "modal-header" }, [
                _createElementVNode("h5", { class: "modal-title" }, "Imagen de Telegram"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: _ctx.mediaUrl,
                  alt: "Imagen de Telegram",
                  class: "img-fluid"
                }, null, 8, _hoisted_10)
              ])
            ])
          ])
        ], 8, _hoisted_6))
      : (_ctx.mediaType === 'video' && _ctx.mediaUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "video-thumbnail-container",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openVideoModal && _ctx.openVideoModal(...args))),
              "data-bs-toggle": "modal",
              "data-bs-target": `#videoModal-${_ctx.uniqueId}`
            }, [
              _createElementVNode("video", {
                src: _ctx.mediaUrl,
                class: "telegram-media-video-thumbnail",
                onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleVideoError && _ctx.handleVideoError(...args))),
                preload: "metadata"
              }, " Tu navegador no soporta la reproducción de video. ", 40, _hoisted_13),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "video-play-overlay" }, [
                _createElementVNode("i", { class: "fas fa-play-circle" })
              ], -1))
            ], 8, _hoisted_12)
          ]))
        : _createCommentVNode("", true),
    (_ctx.mediaType === 'video' && _ctx.mediaUrl)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "modal fade",
          id: `videoModal-${_ctx.uniqueId}`,
          tabindex: "-1",
          role: "dialog"
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "modal-title" }, "Video de Telegram", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.pauseVideo && _ctx.pauseVideo(...args)))
                })
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("video", {
                  id: `video-player-${_ctx.uniqueId}`,
                  src: _ctx.mediaUrl,
                  controls: "",
                  class: "w-100 rounded"
                }, " Tu navegador no soporta la reproducción de video. ", 8, _hoisted_19)
              ])
            ])
          ])
        ], 8, _hoisted_14))
      : (_ctx.mediaType === 'document' && _ctx.mediaUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-file me-1" }, null, -1)),
              _createElementVNode("a", {
                href: _ctx.mediaUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "alert-link"
              }, " Descargar documento ", 8, _hoisted_22)
            ])
          ]))
        : (!_ctx.isLoading && !_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23))
          : _createCommentVNode("", true)
  ]))
}